import { render } from "./BindWxUserKey.vue?vue&type=template&id=10c5437f&scoped=true"
import script from "./BindWxUserKey.vue?vue&type=script&lang=js"
export * from "./BindWxUserKey.vue?vue&type=script&lang=js"

import "./BindWxUserKey.vue?vue&type=style&index=0&id=10c5437f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c5437f"]])

export default __exports__